import React from 'react';
import { withTheme, Text } from '@rneui/themed';
import { View } from '../elements';
import { Text as SkeletonText } from '../skeleton';
import { ContentButtonBar } from '@annunciate/ui/dist/components/content/ContentButtonBar';
import { Duration } from './Duration';
import { Container, Description } from '../shared';
import { AppearsIn } from './AppearsIn';
export const UnthemedContentBody = ({ content, isLoading = false, children, dataStyle, titleContainerStyle, titleStyle, titleSkeletonStyle, durationStyle, }) => {
    const duration = content?.asset?.duration;
    return (React.createElement(Container, { style: dataStyle },
        isLoading ? (React.createElement(SkeletonText, { style: titleSkeletonStyle, lineWidth: "140" })) : (React.createElement(View, { style: titleContainerStyle },
            React.createElement(Text, { h2: true, bold: true, style: titleStyle }, content?.name))),
        React.createElement(AppearsIn, { item: content }),
        React.createElement(Duration, { xsmall: true, style: durationStyle, duration: duration }),
        React.createElement(ContentButtonBar, { item: content, isLoading: isLoading }),
        React.createElement(Description, { text: content?.description, isLoading: isLoading }),
        React.createElement(View, null, !isLoading && content?.contributions?.map((contribution) => (React.createElement(Text, { small: true, key: contribution.id },
            contribution.type.name,
            " - ",
            contribution.contributor.name)))),
        children));
};
export const ContentBody = withTheme(UnthemedContentBody, 'ContentBody');
//# sourceMappingURL=ContentBody.js.map